function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_35",
  "data-name": "Gruppe 35",
  transform: "translate(-1.868 -1.868)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_36",
  "data-name": "Rechteck 36",
  width: 1.476,
  height: 9.838,
  transform: "translate(8.825 1.868) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_37",
  "data-name": "Rechteck 37",
  width: 1.476,
  height: 9.838,
  transform: "translate(9.868 8.825) rotate(135)"
}));

var SvgDeleteSmall = function SvgDeleteSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_small.87cd3147.svg";
export { ForwardRef as ReactComponent };